import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';
import noDataImage from '../../../../assets/images/no-data.png';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: calc(100% - 60px);
  justify-content: center;
  background-color: ${colors.grey100};
  overflow: hidden;
`;

export const ContentWrapper = styled.div``;

export const ImageContainer = styled.div`
  margin-top: 22px;
  background-image: url(${noDataImage});
  background-repeat: no-repeat;
  background-size: contain;

  min-height: 400px;
  min-width: 524px;
`;

export const TextContainer = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: center;
  color: ${colors.grey500};

  max-width: 710px;
  margin-top: -106px;
`;
